import Vue from 'vue'
import Vuex from 'vuex'

const state = {
    params: {
        page: 1,
        per_page: 30,
        q: {
            region_id: "",
            store_name: "",
            status:"",
            recommend:""
        }
    },
    region_names: []
}

const mutations = {
    changeShopPage(state, val) {
       state.params = val
        // state.params.shopPath = val.shopPath
    },

    regionShopChange(state, val) {
        state.region_names = val
    }
    
}

export default {
    state,
    mutations
}